module.exports = __webpack_public_path__ + "media/4.a294c826.wav";